import { DateTime } from "luxon";

function toLuxonUTC(date: Date) {
  return DateTime.fromJSDate(new Date(date)).toUTC();
}

export { toLuxonUTC };
